module.exports = __webpack_public_path__ + "img/slide5-992.6f732be5.png";